import { addNotification } from '../notificationStore';

// Track the last notification to prevent duplicates
let lastNotification = {
  message: null,
  timestamp: 0,
  id: null
};

/**
 * Debounced version of addNotification that prevents duplicate notifications
 * within a short time period (2 seconds by default)
 *
 * @param {Object} options - Notification options
 * @param {string} options.type - Notification type ('success', 'error', 'warning', etc.)
 * @param {string} options.message - Notification message text
 * @param {number} [debounceTime=2000] - Time in ms to debounce identical messages
 * @returns {number|null} Notification ID or null if debounced
 */
export const debounceNotification = ({ type, message }, debounceTime = 2000) => {
  const currentTime = Date.now();

  // Check if this is a duplicate message within the debounce time
  if (
    message === lastNotification.message &&
    currentTime - lastNotification.timestamp < debounceTime
  ) {
    return null; // Skip duplicate notification
  }

  // New message or enough time has passed
  const id = addNotification({ type, message });

  // Update tracking info
  lastNotification = {
    message,
    timestamp: currentTime,
    id
  };

  return id;
};